import { render, staticRenderFns } from "./CampaignMedia.vue?vue&type=template&id=5e861f74&"
import script from "./CampaignMedia.vue?vue&type=script&lang=js&"
export * from "./CampaignMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports